import { Box, useTheme } from "@mui/material";
import { SquareCheck, TriangleAlert } from "lucide-react";

type IStatusBox = {
    status: "C" | "E" | "N" | "R" | "T" | "W" | "P" | "X" | null | undefined,
    isMandatory?: boolean | null
}

export const StatusBox = ({
  status,
  isMandatory
}: IStatusBox) => {
  const theme = useTheme();

  function statusBox(){
    let props = {};
    let icon = null;
    if(status === "C") {
      props = {
        backgroundColor: theme.customColors.backgroundSecondaryComplete,
        border: `1px solid ${theme.customColors.borderSecondaryComplete}`

      };
      icon = <SquareCheck size={ "0.875rem" } />;
    }
    if(isMandatory && status !== "X") {
      props = {
        backgroundColor: theme.customColors.backgroundWarning,
        borderColor: theme.customColors.borderWarning,
        border: `1px solid ${theme.customColors.borderWarning}`

      };
      icon = <TriangleAlert size={ "0.875rem" }  />;
    }
    
    if(!icon) return <></>;

    return (
      <Box
        tabIndex={ -1 }
        sx={ {
          ...props,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "1.5rem",
          width: "1.75rem",
          borderRadius: "0.25rem",
          color: theme.customColors.textTag 
        } }
      >
        { icon }
      </Box>
    );  
  }

  return statusBox();
};
